import React from "react";
import {
  CheckOutlined,
  EyeInvisibleOutlined,
  InfoCircleOutlined,
  MessageOutlined,
} from "@ant-design/icons";
import { Tag } from "antd";

const CHANNELS = ["Member Portal", "USSD"];

const HIDDEN_FEATURES = [
  { name: "Balance & market valuations" },
  {
    name: "Statement generation",
    detail: "Employer can generate one on their behalf",
  },
  { name: "Linking account on Achieve" },
];

export default class RestrictedSelfServiceNotice extends React.Component {
  render(): JSX.Element {
    return (
      <div className="restricted-notice">
        <p className="restricted-notice-summary">
          This member sees <b>contributions only</b> on the Member Portal and
          USSD.
        </p>
        <div className="restricted-notice-guidance">
          <MessageOutlined />
          <div>
            <span className="restricted-notice-label">
              When speaking with this member
            </span>
            They are <b>sensitive to balance fluctuations</b>. Please
            communicate with them accordingly.
          </div>
        </div>
        <div className="restricted-notice-panels">
          <div className="restricted-notice-panel restricted-notice-visible">
            <span className="restricted-notice-label">
              <CheckOutlined /> Member can see
            </span>
            <b>Contributions</b>
            <div>
              {CHANNELS.map((channel) => (
                <Tag key={channel}>{channel}</Tag>
              ))}
            </div>
          </div>
          <div className="restricted-notice-panel restricted-notice-hidden">
            <span className="restricted-notice-label">
              <EyeInvisibleOutlined /> Hidden from member
            </span>
            {HIDDEN_FEATURES.map(({ name, detail }) => (
              <div key={name}>
                <b>{name}</b>
                {detail && (
                  <span className="restricted-notice-detail">{detail}</span>
                )}
              </div>
            ))}
          </div>
        </div>
        <div className="restricted-notice-redemption">
          <InfoCircleOutlined />
          <span>
            <b>Full balance is shown only at redemption</b>, at the prevailing
            market price.
          </span>
        </div>
      </div>
    );
  }
}
